import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=801f7140&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801f7140",
  null
  
)

export default component.exports